import { BoxV2 as Box } from 'portal-commons';
import React from 'react';

export type TabItem = {
  key: string;
  label: string;
};

interface Props {
  items: TabItem[];
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const ListingTab: React.FC<Props> = ({
  items,
  activeTab,
  onTabChange,
  ...props
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '27px',
        borderBottom: '2px solid #CCCFD0',
        fontSize: 'H400',
        fontWeight: '400',
      }}
      {...props}
    >
      {items.map((item: TabItem) => (
        <Box
          key={item.key}
          sx={{
            display: 'inline-block',
            padding: '0 19px 9px',
            color: activeTab === item.key ? 't.blue100' : 't.black70',
            fontWeight: activeTab === item.key ? 800 : 400,
            borderBottom: activeTab === item.key ? '2px solid #33A7C2' : 'none',
            marginBottom: activeTab === item.key ? '-2px' : '0',
            cursor: 'pointer',
          }}
          onClick={() => onTabChange(item.key)}
        >
          {item.label}
        </Box>
      ))}
    </Box>
  );
};

export default ListingTab;
